import { createFileRoute } from '@tanstack/react-router'
import EditionKeywords from 'Edition/components/sections/Content/EditionKeywords'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/content-editorial')({
    component: EditionKeywords,
})
